<template>
	<div class="preview-modal">
		<div class="preview-header">
			<h2>{{ $t('builder.preview_title') }}</h2>
			<button @click="$emit('close')" class="close-btn">
				&times;
			</button>
		</div>

		<div class="preview-content">
			<iframe 
		     ref="previewFrame"
		     class="preview-iframe"
		     sandbox="allow-scripts allow-same-origin"
		     ></iframe>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'

const props = defineProps({
	template: String,
	style: String,
	script: String
})

const previewFrame = ref(null)

const generatePreviewHTML = () => {
	return `
	      <!DOCTYPE html>
		  <html>
		      <head>
			    <meta charset="utf-8">
				  <title>Preview</title>
					<style>${props.style}</style>
					      <script src="https://unpkg.com/vue@3/dist/vue.global.js"><\/script>
						  </head>
						      <body>
							    <div id="app">${props.template}</div>
								  <script>
									  const app = Vue.createApp({
										    ${props.script}
											    })
												    app.mount('#app')
													  <\/script>
													      </body>
														  </html>
														    `
}

const updatePreview = () => {
	if (!previewFrame.value) return

	const html = generatePreviewHTML()
	const blob = new Blob([html], { type: 'text/html' })
	previewFrame.value.src = URL.createObjectURL(blob)
}

onMounted(updatePreview)

watch(
	() => [props.template, props.style, props.script],
	() => {
		updatePreview()
	},
	{ deep: true }
)
</script>

	<style scoped>
.preview-modal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: white;
	z-index: 1000;
	display: flex;
	flex-direction: column;
}

.preview-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1rem 2rem;
	background: #f5f5f5;
	border-bottom: 1px solid #ddd;
}

.close-btn {
	font-size: 2rem;
	background: none;
	border: none;
	cursor: pointer;
	line-height: 1;
	padding: 0 1rem;
}

.close-btn:hover {
	color: #f44336;
}

.preview-content {
	flex: 1;
	position: relative;
}

.preview-iframe {
	width: 100%;
	height: 100%;
	border: none;
}
</style>
